export default __webpack_public_path__ + "static/media/derecha.dd729608.png";